import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CurrencyDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-currency-view',
  templateUrl: './currency-view.component.html',
  styleUrls: ['./currency-view.component.css'],
})
export class CurrencyViewComponent implements OnInit {
  @Input() currencies: CurrencyDto[];
  currencyForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CurrencyDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  selectedCurrency: any;
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.currencyForm = this.fb.group({ Currencies: this.fb.array([]) });
    this.setCurrency();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display currencies
  setCurrency() {
    const control = this.currencyForm.controls.Currencies as FormArray;
    this.currencies.forEach((e) => {
      control.push(
        this.fb.group({
          CurrencyName: e.CurrencyName,
          CurrencyCode: e.CurrencyCode,
          id: e.id,
        })
      );
    });
  }

  // method to add Currency
  addCurrency() {
    const control = this.currencyForm.controls.Currencies as FormArray;
    control.insert(
      0,
      this.fb.group({
        CurrencyName: ['', Validators.required],
        CurrencyCode: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete currency from arrary list
  deleteCurrency(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.currencyForm.controls.Currencies as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.currencies.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.currencies[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'currency';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('currency');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
